import { render, staticRenderFns } from "./InputIngredient.vue?vue&type=template&id=728fe52c&scoped=true&"
import script from "./InputIngredient.vue?vue&type=script&lang=js&"
export * from "./InputIngredient.vue?vue&type=script&lang=js&"
import style0 from "./InputIngredient.vue?vue&type=style&index=0&id=728fe52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fe52c",
  null
  
)

export default component.exports